// extracted by mini-css-extract-plugin
export default {"container-funded":"FhWkZ","message":"IDysx","action-container":"HyNNd","action-link":"HAbSd","discover":"VHLxW","timer":"f6diH","closed":"ZYwtG"};